module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-hollandsnieuwe.20faa80c.svg";